import BasicButton from "components/BasicInputs/BasicButton";
import { Modal, Skeleton } from "@mui/material";
import Portal from "components/Portal";
import ModalBox from "components/Shared/Modals/ModalBox";
import { SetStateAction, useEffect, useState } from "react";
import { store } from "store/store";
import { apiGetFactor } from "api/factorApi";
import Table from "components/Table2";
import PriceComp from "components/Table2/CellComps/Price";

import Text from "components/Table2/CellComps/Text";
import useCurrency from "helpers/useCurrency";
import { apiEditModdian, apiEditModdianFactor } from "api/moaddian";
import { setConfirm } from "store/actions/appAction";
// import PriceComp from "components/Table2/CellComps/Price";
// import Price from "./comps/Price";

const ModdianModalFactorEdit = (props: { setOpen: React.Dispatch<SetStateAction<{ open: boolean; factorId: string; }>>, open: { open: boolean; factorId: string } }) => {
    const { open, setOpen } = props
    const dispatch = store.dispatch
    const token = store.getState().businessReducer.business.token
    const { defCur } = useCurrency();
    const [factorInfo, setFactorInfo] = useState<Factor | null>(null);
    const [dataForSave, setDataForSave] = useState<{ [key: string | number]: { productId: number | string, price: number } }>({})
    useEffect(() => {
        dispatch(apiGetFactor(open.factorId, "sale", token, (res: Factor) => {
            setFactorInfo(res)
        }))
    }, [open.factorId])
    useEffect(() => {

    }, [])
    const getParams = () => {
        const products = Object.keys(dataForSave).map((x, ix) => {
            const price = dataForSave[x].price
            const productId = dataForSave[x].productId
            return {
                id: x,
                price, productId
            }
        })
        return products
    }
    return (<div>

        <Portal>
            <Modal open={open.open}>
                <ModalBox
                    title="ویرایش فاکتور"
                    onClose={() => setOpen(x => { return { ...x, open: false } })}
                    style={{ body: { padding: 10 }, container: { height: 400, backgroundColor: "white", justifyContent: "space-between" } }}
                    footer={
                        <div className="w-full flex justify-end items-center gap-4 px-4">
                            <BasicButton variant="outlined" onClick={() => {
                                dispatch(setConfirm("اخطار", () => {

                                    dispatch(apiEditModdianFactor({
                                        factorId: open.factorId, params: { products: getParams() }, callBack: (res: any) => {
                                            dispatch(apiEditModdian(factorInfo?.id))
                                            setOpen(x => { return { ...x, open: false } })
                                        }
                                    }))

                                }, undefined, "با انجام این درخواست اطلاعات صورت حساب نیز به سامانه مودیان ارسال میشود آیا مطمئن هستید ؟"))
                            }}>
                                <span>ویرایش فاکتور</span>
                            </BasicButton>
                        </div>
                    }
                >
                    <div className="flex flex-col">

                        {factorInfo === null ? <Skeleton variant="rectangular" /> :
                            <Table
                                headers={[
                                    { label: "کالا" },
                                    { label: "مقدار" },
                                    { label: "مبلغ واحد" },
                                ]}
                                cols={[
                                    { Comp: Text, key: "label", getValue: (item: any) => item.Product.title },

                                    {
                                        Comp: Text,
                                        key: "quantity",
                                        getValue: (item) => (
                                            <div className="flex items-center gap-2">
                                                <span className="text-dark-3 text-xs">{item.unit}</span>
                                                <span className="text-dark-1 text-sm font-bold">{item.quantity}</span>
                                            </div>
                                        ),
                                    },
                                    { Comp: PriceComp, key: "price", options: { currency: defCur.en_title, editable: true, onChange: (val, opt) => { setDataForSave(state => { return { ...state, [val.id]: { price: val.price, productId: val.Product.id } } }); console.log(val, opt, "oooooooooooooooooooooooo") } } },

                                ]}
                                headerColor="#fff"
                                rows={factorInfo?.Factor_Items || []}
                                withoutMenu
                            />
                        }


                    </div>
                </ModalBox>
            </Modal>
        </Portal>
    </div>);
}

export default ModdianModalFactorEdit;